module.exports = __webpack_public_path__ + "img/high.068d15ee.png";